import { FC, useState } from "react";
import { useTranslation } from "react-i18next";
import useEvent from "react-use-event-hook";

import {
  createSuccessResult,
  DirectionEnum,
  IEditAreaWaypointsDrawerProps,
  IInjectedDrawerProps,
  RIGHTBAR_STATION_ROUTE_WIDTH,
  SimpleResult,
} from "@ryde/shared";

import { CommonDefaultDrawer } from "../common-default-drawer";
import { BaseDrawer, FormFooter } from "../drawer";
import { EditAreaWaypointsContent } from "./edit-area-waypoints.content";

export const EditAreaWaypointsDrawer: FC<
  IEditAreaWaypointsDrawerProps & IInjectedDrawerProps
> = ({
  onCloseDrawer,
  drawerNumber,
  direction,
  waypoints: initialWaypoints,
  polygon,
  areaName,
  disabled,
  resolveFn,
}) => {
  const { t } = useTranslation();
  const [waypoints, setWaypoints] = useState(initialWaypoints ?? []);
  const directionLabel =
    direction === DirectionEnum.DropOff
      ? t("area.formLabel.areaWaypointsDirectionB")
      : t("area.formLabel.areaWaypointsDirectionA");

  const handleCancel = useEvent(() => {
    resolveFn?.(new SimpleResult({ success: false }));
    onCloseDrawer();
  });

  const handleSave = useEvent(() => {
    resolveFn?.(createSuccessResult(waypoints));
    onCloseDrawer();
  });

  return (
    <BaseDrawer
      onCloseDrawer={handleCancel}
      drawerNumber={drawerNumber}
      customWidth={RIGHTBAR_STATION_ROUTE_WIDTH}
    >
      <CommonDefaultDrawer
        title={`${t("area.formLabel.editAreaWaypoints")} — ${directionLabel}`}
        onCloseDrawer={handleCancel}
        Footer={
          <FormFooter
            cancelLabel={t("general.CANCEL")}
            saveLabel={t("general.SAVE")}
            onCancelClick={handleCancel}
            onSaveClick={handleSave}
            isSaveDisabled={disabled}
          />
        }
      >
        <EditAreaWaypointsContent
          waypoints={waypoints}
          direction={direction}
          polygon={polygon}
          areaName={areaName}
          disabled={disabled}
          onChange={setWaypoints}
        />
      </CommonDefaultDrawer>
    </BaseDrawer>
  );
};
